// extracted by css-extract-rspack-plugin
export default {"buttonLabel":"eVrrvq"};